<template>
  <div class="base-search">
    <base-input class="base-search__input" placeholder="Search" v-model="searchParameter" @keyup.enter="search" @input="changeSearch" />
    <base-button class="base-search__btn" @click="search">Search</base-button>
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue'
import BaseInput from './BaseInput.vue'
import Search from '@utils/Search.js'
import toast from '@utils/toast.js'

export default {
  name: 'BaseSearch',
  components: { BaseInput, BaseButton },
  props: {
    searchArr: {
      type: Array,
      required: true,
    },
    fieldsString: {
      type: Array,
      required: true,
    },
    fieldsNumber: {
      type: Array,
      required: true,
    },
    fieldsExtra: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      searchParameter: '',
    };
  },
  methods: {
    search() {
      let searchResult = []
      if (this.searchParameter !== '') {
        let inputFields = null
        let string = false
        if (isNaN(this.searchParameter)) {
            inputFields = this.fieldsString
            string = true
        } else {
            inputFields = this.fieldsNumber
            this.searchParameter = parseInt(this.searchParameter)
        }
        const searchObject = new Search(inputFields, this.searchArr, this.searchParameter, Object.keys(this.searchArr[0]), string, this.fieldsExtra)
        searchObject.search().then((value) => {
            if (value.length === 0) {
                toast.simpleMessage('No result found from the search')
            } else {
                toast.successMessage('Search result received')
            }
            searchResult = value
            this.$emit('search', searchResult)
        })
      } else {
        searchResult = this.searchArr
      }
        this.$emit('search', searchResult)
    },

    changeSearch() {
      if ( this.searchParameter === '') {
        this.$emit('search', this.searchArr)
      }
    }
  }
}
</script>

<style>
.base-search__input {
  margin-right: 15px;
}

</style>